// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_SendMessagesInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /mensagens_programadas/send_messages
 *
 * Schedules WhatsApp messages from templates for multiple clients.
 *
 * Required fields:
 * - messages           : list of cliente/template/device triples (typed as Row[])
 * - current_datetime   : ISO 8601 UTC timestamp the controller stamps onto each scheduled message
 */
import type { MensagensProgramadas_SendMessageInputRow } from './MensagensProgramadas_SendMessageInputRow'
import { registerContract } from './validate'

export interface MensagensProgramadas_SendMessagesInput {
messages: MensagensProgramadas_SendMessageInputRow[]
current_datetime: string
}

registerContract('MensagensProgramadas_SendMessagesInput', {
  messages: {
    type: 'array',
    required: true,
    items: {
      cliente_id:          { type: 'number',  required: true },
      template_id:         { type: 'number',  required: true },
      whatsappfranquia_id: { type: 'number',  required: true },
      user_id:             { type: 'number',  required: false },
    },
  },
  current_datetime: { type: 'string',  required: true },
})
